import { language as en } from './en';

const it = {
    defaults: {
        no_results: 'Nessun risultato trovato.',
        not_found: 'Pagina non trovata.',
        rows: 'Righe',
        columns: 'Colonne',
        view: 'Visualizza',
        edit: 'Modifica',
        delete: 'Elimina',
        clear: 'Resetta',
        image: 'Immagine',
        delete_title: 'Elimina elemento',
        delete_msg: 'Confermi di voler rimuovere questo elemento?',
        details: 'Dettagli',
        close: 'Chiudi',
        open: 'Apri',
        error: 'Errore',
        save: 'Salva',
        back: 'Torna indietro',
        back_to_home: 'Torna alla home',
        search: 'Cerca',
        create: 'Crea nuovo',
        results_per_page: 'Risultati per pagina',
        no_image: 'Nessuna immagine.',
        loading: 'Caricamento',
        true: 'Sì',
        false: 'No',
        select: 'Seleziona elemento',
        select_file: 'Seleziona file',
        add: 'Aggiungi',
        options: 'Opzioni',
        import: 'Importa',
        export: 'Esporta',
        paste_here: 'Incolla qui',
        check: 'Controlla',
        reset: 'Reset',
        preview: 'Anteprima',
        download: 'Scarica',
        open_link: 'Apri link',
        open_file: 'Apri file',
        elements: 'Elementi',
        refresh: 'Ricarica',
        clone: 'Duplica'
    },
    search: {
        filters: 'Filtri di ricerca',
        search_fields: 'Campi di ricerca',
        search_fields_subtitle: 'Seleziona o deseleziona i campi su cui effettuare la ricerca.',
        add_filter: 'Aggiungi filtro',
        add_filter_subtitle: 'Aggiungi filtri standard su campi specifici.',
        active_filters: 'Filtri attivi',
        active_filters_subtitle: 'Gestisci i filtri attualmente attivi sulla ricerca.',
        field_label: 'Campo',
        type_label: 'Tipo filtro',
        field_value: 'Valore',
        select_constraint_field: 'Seleziona prima il campo del filtro.'
    },
    errors: {
        insert: 'Si è verificato un errore. Controlla i campi e riprova.',
        update: 'Si è verificato un errore. Controlla i campi e riprova.',
        get: 'Si è verificato un errore.'
    },
    header: {
        home: 'Homepage',
        profile: 'Profilo',
        settings: 'Impostazioni',
        notifcations: 'Notifiche',
        search: 'Ricerca',
        about: 'Informazioni',
        logout: 'Logout',
        collection: 'Collezione'
    },
    login: {
        title: 'Effettua il login',
        subtitle: '',
        username: 'Utente',
        password: 'Password',
        login: 'Accedi',
        forgot: 'Hai dimenticato la password?',
        remember: 'Ricordami',
        send_forgot_password_key: 'Invia pin',
        reset_password: 'Resetta la tua password',
        insert_password_key: 'Inserisci il pin che hai ricevuto via e-mail e la nuova password. Se non hai ricevuto il pin controlla anche nella posta indesiderata.',
        password_key: 'Pin ricevuto',
        new_password: 'Nuova password',
        confirm_new_password: 'Conferma password',
        confirm_reset: 'Conferma',
        back_to_login: 'Torna al login',
        change_password: 'Devi modificare la password',
        change_password_desc: 'Riceverai un pin via e-mail da inserire nel prossimo step per modificare la tua password.'
    },
    logout: {
        title: 'Stai per eseguire il logout.',
        subtitle: 'Una volta disconnesso verranno automaticamente rimossi tutti i dati temporanei relativi alla tua sessione. Verranno comunque salvati tutti i progressi e ricaricati al tuo prossimo login.',
        confirm: 'Confermo'
    },
    settings: {
        user_settings: 'Impostazioni utente',
        general: 'Generali',
        avatar: 'Immagine profilo',
        security: 'Sicurezza',
        name: 'Nome',
        surname: 'Cognome',
        sex: 'Sesso',
        general_success: 'Profilo modificato con successo.',
        general_save: 'Modifica profilo',
        female: 'Donna',
        male: 'Uomo',
        password: 'Password attuale',
        new_password: 'Nuova password',
        confirm_password: 'Conferma nuova password',
        security_save: 'Modifica password',
        security_success: 'Password modificata con successo.',
        passwords_match_error: 'Le password non coincidono.',
        avatar_save: 'Aggiorna avatar',
        avatar_now: 'Immagine profilo attuale',
        avatar_success: 'Immagine profilo modificata con successo.'
    },
    header: {
        home: 'Home',
        blog: 'Notizie',
        account: 'Il mio account',
        help: 'Aiuto',
        profile: 'Modifica profilo',
        logout: 'Esci',
        new_collection: 'Spring Summer 2024',
        old_collection: "fuori collezione"
    },
    title : {
        fantasie_evidenza: 'Fantasie in evidenza'
    },
    buttons: {
        accedi: "ACCEDI",
        invia: "INVIA",
        registrati: "REGISTRATI",
        salva: "SALVA"
    },
    forms: {
        contattaci: "contattaci",
        accedi: "accedi",
        accedi_subtitle: "Inserisci i tuoi dati per continuare.",
        accedi_footer: "Non hai un'account?",
        registrati_footer: "Hai già un'account?",
        registrati: "registrati",
        registrati_subtitle: "Conosciamoci meglio."
    },
    footer: {
        iva: "01670490273",
        via: "Via della Pianca 2",
        citta: "30028 San Michele al Tagliamento",
        provincia: "(VE)",
        stato: "Italia",
        telefono: "0431 50552",
        mail: "info@annamaria.com",
        copyright: "© 2024 GRUPPO YEC. All rights reserved."
    },
    headerTexts: {
        explore: 'Esplora posizioni aperte',
        reserved: 'Area riservata'
    },
    footerTexts: {
        payoff: 'Lavoriamo l’acciaio con passione dal 1949',
        headOffice: 'SEDE CENTRALE',
        regOffice: 'SEDE LEGALE',
        contactUs: 'CONTATTACI',
        followUs: 'SEGUICI',
        legal: {
            integratedQualityBim: 'Qualità integrata e BIM',
            policy: 'Policy',
            codeOfEthics: 'Codice etico',
            privacyPolicy: 'Privacy Policy',
            privacyPolicyUrl: 'https://www.cimolai.com/it/privacy-policy/',
            cookiePolicy: 'Cookie Policy',
            cookiePolicyUrl: 'https://www.cimolai.com/it/cookie-policy/',
            candidatesPrivacyPolicy: 'Privacy policy relativa ai candidati',
            integratedPolicy: 'Politica integrata',
            whistleblowing: 'Whistleblowing',
            rightsReserved: 'Tutti i diritti riservati'
        }
    },
    pages: {
        profileSettings: {
            title: 'Impostazioni',
            notifications: 'Notifiche',
            yourData: 'I tuoi dati',
            logout: 'Logout',
            placeholders: {
                name: 'Nome',
                surname: 'Cognome',
                email: 'Email',
                phone: 'Numero di telefono',
                nation: 'Nazione',
                province: 'Provincia',
                currentPassword: 'Password attuale',
                newPassword: 'Nuova password',
                confirmPassword: 'Conferma password'
            },
            switches: {
                apps: 'Notifiche email relative alle candidature inviate',
                new: 'Notifiche mail per nuove posizioni aperte'
            },
            buttons: {
                save: 'Salva',
                changePassword: 'Modifica password',
                logout: "Esci dall'account"
            },
            back: 'Indietro'
            ,
            passwordModal: {
                title: 'Modifica password'
            }
        },
        recover: {
            title: 'Reset password',
            emailLabel: 'La tua mail',
            sendCode: 'Invia codice',
            otpTitle: 'Ti abbiamo inviato un codice OTP',
            otpDesc: 'Apri la tua mail e riporta il codice OTP ricevuto nel box qui sotto.',
            otpPlaceholder: 'Codice OTP',
            resendOtp: 'Rimanda codice OTP',
            verifying: 'Verifica…',
            verify: 'Verifica',
            newPassword: 'Nuova password',
            confirmPassword: 'Conferma password'
        },
        addressInput: {
            placeholder: 'Inserisci un indirizzo',
            save: 'Salva',
            close: 'Chiudi'
        },
        jobApplyReview: {
            sending: 'Invio in corso…',
            submit: 'Invia candidatura',
            emptyError: 'Aggiungi almeno una risposta',
            duplicateError: 'Hai già inviato una candidatura per questa posizione.',
            privacyTitle: 'PRESA VISIONE DELLA PRIVACY POLICY',
            privacyBodyHtml: 'Ho letto e compreso il contenuto della <a href="https://www.cimolai.com/it/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a> e <a href="/privacy-candidati" target="_blank" rel="noreferrer">Privacy Policy relativa ai candidati</a>, fornite ai sensi del Regolamento (UE) 2016/679',
            modal: {
                title: 'Candidatura inviata con successo!',
                body: 'Ti abbiamo appena inviato una mail di conferma',
                close: 'Chiudi'
            }
        },
        profile: {
            greeting: 'Ciao,',
            applied: 'Candidature',
            favourites: 'Preferiti',
            searchPlaceholder: 'Ricerca per nome...',
            noApplied: 'Non ci sono candidature inviate.',
            noFavourites: 'Non ci sono preferiti.',
            exploreLink: 'Esplora posizioni aperte',
            settingsAria: 'Impostazioni'
        },
        jobExplore: {
            title: 'Posizioni aperte',
            results: 'risultati',
            noResults: 'Nessuna posizione aperta trovata con i filtri attuali.',
            noResultsEmpty: 'Non abbiamo alcuna posizione aperta al momento. Riprova più tardi.',
            filters: {
                country: 'Nazione',
                site: 'Sede di lavoro',
                sector: 'Settore',
                role: 'Ruolo',
                searchPlaceholder: 'Ricerca per nome...',
                applied: 'Filtri attivi',
                labelCountry: 'Nazione',
                labelSite: 'Sede',
                labelSector: 'Settore',
                labelRole: 'Ruolo',
                labelSearch: 'Ricerca'
            },
            pagination: {
                perPage: 'Risultati per pagina'
            }
        },
        jobDetail: {
            back: 'Indietro',
            applyNow: 'Candidati ora',
            appliedAlready: 'Candidatura già inviata',
            notOpen: 'La posizione non è più aperta',
            description: 'Descrizione',
            workplace: 'Luogo di lavoro',
            country: 'Nazione',
            role: 'Ruolo',
            sector: 'Settore'
        },
        jobApply: {
            applyingFor: 'Candidatura per:',
            cancel: 'Annulla',
            next: 'Avanti',
            steps: {
                loginRegister: 'Login / Registrazione',
                additionalData: 'Dati aggiuntivi',
                reviewAndSend: 'Ricontrolla e invia'
            },
            position: 'Posizione',
            filePlaceholder: 'Nessun file selezionato',
            uploadFile: 'Carica file',
            removeFile: 'Rimuovi',
            fileTooLarge: 'Il file supera la dimensione massima consentita'
        },
    login: {
        heading: 'Entra nel mondo CIMOLAI',
        login: 'Login',
        register: 'Registrazione',
        usernamePlaceholder: 'Email',
        passwordPlaceholder: 'Password',
            phone: 'Numero di telefono',
            country: 'Nazione di residenza',
            province: 'Provincia di residenza',
            password: 'Password',
            passwordRepeat: 'Ripeti password',
            notificationsApps: 'Notifiche email relative alle candidature inviate',
            notificationsNew: 'Notifiche mail per nuove posizioni aperte',
            privacyAcceptance: 'ACCETTAZIONE PRIVACY POLICY',
            adultDeclaration: 'DICHIARO DI ESSERE MAGGIORENNE',
            registerCta: 'Registrati',
        registering: 'Registrazione…'
        },
        reset: {
            key: 'Codice',
            password: 'Password',
            confirmPassword: 'Conferma password',
            submit: 'Invia'
        },
        home: {
            emailPlaceholder: 'Indirizzo email'
        },
        register: {
            name: 'Nome',
            surname: 'Cognome',
            email: 'Indirizzo email',
            password: 'Password',
            submit: 'Registrati'
        }
    }
};

function getLangCode() {
  try {
    const c = localStorage.getItem('lang');
    return c === 'eng' ? 'eng' : 'ita';
  } catch {
    return 'ita';
  }
}

function selectPack() {
  return getLangCode() === 'eng' ? en : it;
}

function makeNode(path = []) {
  return new Proxy({}, {
    get(_, prop) {
      const nextPath = path.concat([prop]);
      let val = selectPack();
      for (const k of nextPath) {
        val = val ? val[k] : undefined;
      }
      if (val && typeof val === 'object') {
        return makeNode(nextPath);
      }
      return val;
    }
  });
}

export const language = makeNode();
